import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrlWithPathVariable, sitConfig } from './config'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  const respData = {
    ...data,
    content: data?.content?.map((item: any) => {
      return {
        id: item?.id?.toString() ?? '',
        entityId: item?.entityId,
        entityID: item?.entityId,
        bankName: item?.bankName,
        entityCode: item?.entityCode,
        rpslCode: item?.rpslCode,
        status: item?.status,
      }
    }),
  }

  return respData
}

const getNetbankingByEntity = (id: any, pageInfo: any, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrlWithPathVariable(APIEndPoints.nBMappingByEntity, id),
    method: 'POST',
    cache: false,
    body: pageInfo,
    config: sitConfig(tokens),
    headers: getHeaders(),
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getNetbankingByEntity }
